/* unplugin-vue-components disabled */import script from "./SystemDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./SystemDialog.vue?vue&type=script&setup=true&lang=ts"

import "./SystemDialog.vue?vue&type=style&index=0&id=6d45951a&lang=scss"

const __exports__ = script;

export default __exports__